import { styled } from "@mui/material/styles";
import { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";
import { Tooltip } from "@mui/material";

const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip
    data-html="true"
    {...props}
    arrow
    open={props.open}
    classes={{ popper: className }}
    componentsProps={{
      tooltip: {
        sx: {
          padding: "6px 9px 7px 11px",
          fontSize: "12px",
          fontFamily: "Lato",
          fontStyle: "normal",
          fontWeight: "400",
          lineHeight: "14px",
          display: "flex",
          flexDirection: "column",
          marginTop: "5px",
          color: "#FFFFFF",
        },
      },
    }}
  />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.black,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.black,
  },
}));

export default BootstrapTooltip;
